export const MetadataCategoryCode = {
    market: 'market',
    scope: 'scope',
    subsidiary: 'subsidiary',
    //hardware: 'hardware',
    hwplatform: 'hw platform',
};